import { supabase } from '../supabase';

/** Business unit inside one exporter account (e.g. Unifrutti / Verfrut). */
export interface ExporterDivision {
  id: number;
  exporter_id: number;
  name: string;
  is_default: boolean;
}

export const getExporterDivisions = async (
  exporterId: number
): Promise<ExporterDivision[]> => {
  const { data, error } = await supabase
    .from('exporter_divisions')
    .select('id, exporter_id, name, is_default')
    .eq('exporter_id', exporterId)
    .order('is_default', { ascending: false })
    .order('name');

  if (error) throw error;
  return (data || []) as ExporterDivision[];
};

// Writes are superadmin-only (RLS). Errors keep the Postgres code for the UI.
export const createExporterDivision = async (
  exporterId: number,
  name: string
): Promise<ExporterDivision> => {
  const { data, error } = await supabase
    .from('exporter_divisions')
    .insert({ exporter_id: exporterId, name: name.trim() })
    .select('id, exporter_id, name, is_default')
    .single();
  if (error) throw error;
  return data as ExporterDivision;
};

export const renameExporterDivision = async (
  id: number,
  name: string
): Promise<ExporterDivision> => {
  const { data, error } = await supabase
    .from('exporter_divisions')
    .update({ name: name.trim() })
    .eq('id', id)
    .select('id, exporter_id, name, is_default')
    .single();
  if (error) throw error;
  return data as ExporterDivision;
};
